function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getComponentName } from '../utils/utils.js';
class ErrorBoundary extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {});
    _defineProperty(this, "componentDidCatch", (error, info) => {
      console.log(error); // eslint-disable-line
      const {
        id,
        name,
        onError
      } = this.props;
      const {
        componentStack
      } = info || {};
      const componentName = getComponentName(componentStack);
      if (onError) {
        onError({
          error,
          id,
          info,
          name
        });
      }
      if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
        window.LIFE_CYCLE_EVENT_BUS.trigger('error-boundary.error', {
          componentName,
          componentStack,
          error,
          id,
          name
        });
      }
      return null;
    });
  }
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  render() {
    const {
      children
    } = this.props;
    const {
      hasError
    } = this.state;
    if (hasError) {
      return null;
    }
    return children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  name: PropTypes.string,
  onError: PropTypes.func
};
ErrorBoundary.defaultProps = {
  id: null,
  name: null,
  onError: null
};
ErrorBoundary.displayName = 'ErrorBoundary';
export { ErrorBoundary };
//# sourceMappingURL=ErrorBoundary.js.map